/**
 * Matches backend `hasGlobalAdminBypass`: Admin / Super Admin (tolerant of spacing & case).
 * @param {{ role?: { name?: string } } | null | undefined} user
 */
export function isGlobalAdminUser(user) {
  const raw = user?.role?.name;
  if (raw == null) return false;
  const key = String(raw)
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '')
    .replace(/[^a-z0-9]/g, '');
  return key === 'admin' || key === 'administrator' || key === 'superadmin';
}

export const GLOBAL_ADMIN_MENU_TAG = '__GLOBAL_ADMIN__';
